import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import Storages from 'js-storage'
import axios from 'axios'

Vue.config.productionTip = false;

const storage = Storages.localStorage;

var session_key = "__NOT_AUTHENTICATED__";

if (storage.isSet('session_key')) {
	session_key = storage.get('session_key');
}

axios.get('https://bakerstreet.arturs.co.uk/api/lostinthecity/session?key=' + session_key + '&cachebuster=' + (new Date()).getTime())
.then(function (response) {
	var data = response.data;

	if (data.success == true) {
		if (data.response.authenticated == true) {
			storage.set('authed_user', data.response.user);

			if (parent) {
				parent.postMessage({type: "user", user: data.response.user}, "*");
			}
		} else {
			storage.remove('authed_user');
			storage.remove('session_key');

			if (parent) {
				parent.postMessage({type: "user", user: null}, "*");
			}
		}

		storage.set('welcome_alert', data.response.welcome_alert);
		storage.set('disable_challenges_alert', data.response.disable_challenges_alert);
		storage.set('online_config', data.response.online_config);
	} else {
		alert(data.response);
	}
})
.catch(function (error) {
	if (parent) {
		parent.postMessage({type: "user", user: null}, "*");
	}
	
	if (error.response) {
		var data = error.response.data;
		alert(data.response);
	} else {
		alert("An error occured while loading your details");
	}
})
.then(() => {
	new Vue({
		router,
		render: function (h) { return h(App) }
	}).$mount('#app')
});
